import { s } from '@/theme/tokens';

export const settingsTabbedPageSectionGap = 'xl' as const;
export const settingsTabbedPageMainContentWidth = '600px';
export const settingsTabbedPageRailWidth = '240px';
export const settingsTabbedPageColumnGap = s('xl');
export const settingsTabbedPageOuterWidth = `calc(${settingsTabbedPageMainContentWidth} + ${settingsTabbedPageColumnGap} + ${settingsTabbedPageRailWidth})`;
export const settingsTabbedPageHorizontalOffset = `calc((${settingsTabbedPageRailWidth} + ${settingsTabbedPageColumnGap}) / 2)`;
export const settingsTabbedPageCompactLeftInset = s('sm');
export const settingsTabbedPageCompactRightInset = s('md');

export const settingsTabbedPageModuleLayoutSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: `${settingsTabbedPageMainContentWidth} minmax(0, ${settingsTabbedPageRailWidth})`,
  },
  columnGap: settingsTabbedPageColumnGap,
  rowGap: s(settingsTabbedPageSectionGap),
  alignItems: 'start',
} as const;
